import { checkInStateOn, assertLoggingAllowed } from "../../domain/check-in/state-machine";
import { updateDiaryEntry as updateDiaryEntrySnapshot, type DiaryEntry } from "../../domain/diary/diary-entry";
import type { FoodPortion } from "../../domain/foods/food";
import type { CalendarDate } from "../../domain/shared/calendar-date";
import type { Clock } from "../ports/clock";
import type { DiaryRepository, WeekPlanRepository } from "../ports/repositories";

export async function updateDiaryEntry(
  dependencies: {
    readonly diary: DiaryRepository;
    readonly weekPlans: WeekPlanRepository;
    readonly clock: Clock;
  },
  input: {
    readonly entryId: string;
    readonly date: CalendarDate;
    readonly meal?: string;
    readonly portion: FoodPortion;
  },
): Promise<DiaryEntry> {
  const [entry, plan] = await Promise.all([
    dependencies.diary.getById(input.entryId),
    dependencies.weekPlans.getOpen(),
  ]);
  if (!entry) throw new Error("Diary entry not found");
  if (!plan) throw new Error("No active week plan exists");

  const state = checkInStateOn(plan, dependencies.clock.today());
  const intent = state === "overdue_locked" ? "check_in_backfill" : "normal";
  assertLoggingAllowed(plan, dependencies.clock.today(), entry.date, intent);
  assertLoggingAllowed(plan, dependencies.clock.today(), input.date, intent);

  const updated = updateDiaryEntrySnapshot(entry, {
    date: input.date,
    meal: input.meal,
    portion: input.portion,
    now: dependencies.clock.now(),
  });
  await dependencies.diary.save(updated);
  return updated;
}
